export const iconFontAwesomeMapsMagnifyingGlassPlus = (
	<i className="fa-solid fa-magnifying-glass-plus"></i>
);
